import React from "react";
import { useLocation } from "react-router-dom";

import Layout from "../../../components/Layout";

export default function BikeVariantsMain({ children }) {
  const location = useLocation();

  return (
    <Layout>
      <div className="row dashboard">
        <div className="d-flex">
          <div className="margin-heading col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-4 col-6">
            {location.pathname === "/bike-version" ? <></> : null}
          </div>
        </div>
        <div>{children}</div>
      </div>
    </Layout>
  );
}
